import React from 'react';
import { Link } from 'react-router-dom';
import { PageHeader } from '../components/ui/PageHeader';
import { Section } from '../components/ui/Section';
import { ArrowRight } from 'lucide-react';

const articles = [
  {
    id: 'optimization-without-coherence',
    title: 'Why Optimization Without Coherence Breaks the Future',
    abstract: 'Modern systems are optimized to succeed—but rarely governed to remain compatible with the futures they create. This essay explains why optimization alone, when unconstrained by coherence, systematically generates downstream instability, legitimacy loss, and unintended harm—especially at scale.',
  },
  {
    id: 'governance-is-not-control',
    title: 'Governance Is Not Control: Why the Future Needs Constraint-Based Systems',
    abstract: 'Governance is often mistaken for oversight or restraint applied after the fact. This essay introduces governance as a design discipline—one that operates upstream through constraints that shape what systems are able to produce in the first place.',
  },
  {
    id: 'from-metrics-to-meaning',
    title: 'From Metrics to Meaning: Why Measurement Must Evolve',
    abstract: 'Metrics were designed to accelerate performance—but not to preserve the conditions that make performance sustainable. This essay examines why measurement itself must evolve as systems scale.',
  },
  {
    id: 'systems-that-deserve-to-win',
    title: 'Building Systems That Deserve to Win',
    abstract: 'Not all success strengthens the future it depends on. This essay explores the distinction between systems that merely outperform and systems whose success reinforces the conditions that allow progress to continue.',
  },
  {
    id: 'hidden-cost-of-success',
    title: "The Hidden Cost of Success: A Founder's View from Inside Systems",
    abstract: "Having built and observed systems that worked exactly as designed, this essay reflects on the less-visible consequences of success at scale—and why a different governing approach becomes inevitable once those patterns are understood.",
  },
];

const ArticleEntry = ({ article }) => (
  <article className="py-12 first:pt-0 last:pb-0 border-b border-border/50 last:border-0">
    <Link 
      to={`/articles/${article.id}`}
      className="group block"
    >
      <h2 className="font-serif text-2xl md:text-3xl font-medium text-foreground mb-4 group-hover:text-accent transition-colors">
        {article.title}
      </h2>
      <p className="text-muted-foreground leading-relaxed mb-6 max-w-2xl">
        {article.abstract}
      </p>
      <span className="text-cta text-sm">
        Read Essay
        <ArrowRight className="w-4 h-4 ml-2 group-hover:translate-x-1 transition-transform" />
      </span>
    </Link>
  </article>
);

const ArticlesPage = () => {
  return (
    <div>
      <PageHeader 
        title="Articles"
        subtitle="Position papers and essays on coherence, governance, and the future of systems"
      />

      <Section>
        <div className="divide-y divide-border/50">
          {articles.map((article) => (
            <ArticleEntry key={article.id} article={article} />
          ))}
        </div>
      </Section>
    </div>
  );
};

export default ArticlesPage;
